import LivestreamingBanner from 'shared/components/livestreaming_banner';

export default class DesktopLivestreamingBanner extends LivestreamingBanner {
  constructor(options) {
    super(options);
    this.expand = true;
    this.platform = 'web-desktop';
  }
}
